import { Amplify } from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import client from './apollo/client'
import App from './App.jsx'
import { UserProvider } from './context/UserContext.jsx'
import { DownloadQueueProvider } from './context/DownloadQueueContext.jsx'
import './index.css'
import awsmobile from './aws/aws-exports'
import * as Sentry from "@sentry/react";

Amplify.configure(awsmobile)

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/admin-develop\.saddlefit\.io\//,
    /^https:\/\/staging-develop\.saddlefit\.io\//,
    /^https:\/\/admin\.saddlefit\.io\//
  ],
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <UserProvider>
        <DownloadQueueProvider>
          <App />
        </DownloadQueueProvider>
      </UserProvider>
    </BrowserRouter>
  </ApolloProvider>,
)
